/**
 * @internal
 */
import React, { createContext, useContext } from 'react';
import Themes from '@polestar/component-warehouse-react/themes/Themes';
import { ThemeProvider } from '@emotion/react';
export const ThemesContext = createContext({
    themes: Themes,
});
const ThemesProvider = ({ themes, theme, children, }) => {
    return (React.createElement(ThemesContext.Provider, { value: { themes } },
        React.createElement(ThemeProvider, { theme: theme }, children)));
};
export default ThemesProvider;
export const useThemes = () => {
    return useContext(ThemesContext).themes;
};
